import { errorTypes } from '../../reducers/types';

export default error => ({
  type: errorTypes.ADD_ERROR,
  payload: error,
});
